export const CHECKLIST_PAGINATION_DEFAULT_PER_PAGE_VALUE = 5;
export const PAGINATION_DEFAULT_PER_PAGE_VALUE = 5;
export const SORT_TYPE_DESC = 'desc';
export const PAGINATION_FIRST_PAGE = 1;

export const DEFAULT_PAGINATION_OPTIONS = [
  { label: '5', value: '5' },
  { label: '10', value: '10' },
  { label: '20', value: '20' },
  { label: '50', value: '50' },
  { label: '100', value: '100' },
];

export const DEFAULT_ELEMENTS_PER_PAGE = [
  { label: PAGINATION_DEFAULT_PER_PAGE_VALUE, value: PAGINATION_DEFAULT_PER_PAGE_VALUE },
];
